import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { LISTA_TIPOS_TURMA, SALVA_TIPO_TURMA, ATUALIZA_TIPO_TURMA, REMOVE_TIPO_TURMA } from 'constants/ActionTypes';
import requisicaoApi from 'util/Api';
import { listaTiposTurmaSucesso, showAuthMessage, showSuccessMessage } from 'actions/TipoTurma';

const getTiposTurma = async (search) =>
  await requisicaoApi.get('/tipos-turma', { params: { search: search || '' } })
    .then(resposta => resposta)
    .catch(error => error);

const postTipoTurma = async (payload) =>
  await requisicaoApi.post('/tipos-turma', payload)
    .then(resposta => resposta)
    .catch(error => error);

const putTipoTurma = async (id, payload) =>
  await requisicaoApi.put(`/tipos-turma/${id}`, payload)
    .then(resposta => resposta)
    .catch(error => error);

const deleteTipoTurma = async (id) =>
  await requisicaoApi.delete(`/tipos-turma/${id}`)
    .then(resposta => resposta)
    .catch(error => error);

function* fnListaTiposTurma({ payload }) {
  try {
    const search = payload && payload.search;
    const retorno = yield call(getTiposTurma, search);
    if (retorno.message) {
      yield put(showAuthMessage(JSON.stringify(retorno.message)));
    } else {
      const data = retorno.data;
      const lista = Array.isArray(data) ? data : (Array.isArray(data?.tipos) ? data.tipos : (Array.isArray(data?.Tipos) ? data.Tipos : []));
      yield put(listaTiposTurmaSucesso(lista));
    }
  } catch (error) {
    yield put(showAuthMessage(JSON.stringify(error)));
  }
}

function* fnSalvaTipoTurma({ payload }) {
  try {
    const body = { titulo: payload?.titulo, sigla: payload?.sigla };
    const retorno = yield call(postTipoTurma, body);
    if (retorno.message) {
      yield put(showAuthMessage(JSON.stringify(retorno.message)));
    } else {
      yield put(showSuccessMessage('Tipo de turma criado com sucesso!'));
      yield put({ type: LISTA_TIPOS_TURMA, payload: { search: '' } });
    }
  } catch (error) {
    yield put(showAuthMessage(JSON.stringify(error)));
  }
}

function* fnAtualizaTipoTurma({ payload }) {
  try {
    const id = payload?.id;
    const body = { titulo: payload?.tipo?.titulo, sigla: payload?.tipo?.sigla };
    const retorno = yield call(putTipoTurma, id, body);
    if (retorno.message) {
      yield put(showAuthMessage(JSON.stringify(retorno.message)));
    } else {
      yield put(showSuccessMessage('Tipo de turma atualizado com sucesso!'));
      yield put({ type: LISTA_TIPOS_TURMA, payload: { search: '' } });
    }
  } catch (error) {
    yield put(showAuthMessage(JSON.stringify(error)));
  }
}

function* fnRemoveTipoTurma({ payload }) {
  try {
    const id = payload;
    const retorno = yield call(deleteTipoTurma, id);
    if (retorno.message) {
      yield put(showAuthMessage(JSON.stringify(retorno.message)));
    } else {
      yield put(showSuccessMessage('Tipo de turma removido com sucesso!'));
      yield put({ type: LISTA_TIPOS_TURMA, payload: { search: '' } });
    }
  } catch (error) {
    yield put(showAuthMessage(JSON.stringify(error)));
  }
}

export default function* rootSaga() {
  yield all([
    fork(function*() { yield takeEvery(LISTA_TIPOS_TURMA, fnListaTiposTurma); }),
    fork(function*() { yield takeEvery(SALVA_TIPO_TURMA, fnSalvaTipoTurma); }),
    fork(function*() { yield takeEvery(ATUALIZA_TIPO_TURMA, fnAtualizaTipoTurma); }),
    fork(function*() { yield takeEvery(REMOVE_TIPO_TURMA, fnRemoveTipoTurma); })
  ]);
}

